import React from 'react';

import { AlertTriangle } from 'lucide-react';

const ErrorBox = ({ description }) => {
  return (
    <div className="flex flex-col flex-1 items-center justify-center p-8 text-center">
      <AlertTriangle className="h-16 w-16 text-yellow-500"/>
      
      <h3 className="mt-4 text-xl font-semibold text-gray-800">
        Something went wrong
      </h3>
      
      <p className="mt-2 text-gray-500">
        {description}
      </p>
      
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-6 rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      >
        Try Again
      </button>
    </div>
  );
};

export default ErrorBox;
